/*
 * Application Insights JavaScript SDK - Core, 3.4.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * A simple function that does nothing and returns the current this (if any).
 * @returns
 */
export function _noopThis() {
    return this;
}
/**
 * A simple function that does nothing and returns undefined.
 */
export function _noopVoid() {
}
//# sourceMappingURL=noopHelpers.js.map